import { render, staticRenderFns } from "./ChannelThreeNews.vue?vue&type=template&id=978af7b8&scoped=true"
import script from "./ChannelThreeNews.vue?vue&type=script&lang=js"
export * from "./ChannelThreeNews.vue?vue&type=script&lang=js"
import style0 from "./ChannelThreeNews.vue?vue&type=style&index=0&id=978af7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978af7b8",
  null
  
)

export default component.exports